import { getStore } from '../store/Store';

/** Selector function which returns whether ActivityPane is shown or not */
export function isActivityPaneShown() {
    return getStore().isActivityPaneOpen;
}
